import { getUrlExcludingUrlParameter, hasUrlParameter, removeUrlParameterWithoutReload } from '../../../utils/url-utils';
const redirectTokenUrlParameterName = 'token';
/**
 * Returns whether the 'token' url parameter is present. This is provided by Web Payment Module when returning from a redirect payment page.
 */
export const hasRedirectTokenUrlParameter = () => {
    return hasUrlParameter(redirectTokenUrlParameterName);
};
export const removeRedirectTokenUrlParamter = () => {
    removeUrlParameterWithoutReload(redirectTokenUrlParameterName);
};
export const getUrlExcludingRedirectToken = () => {
    return getUrlExcludingUrlParameter(redirectTokenUrlParameterName);
};
